import HealthcareSitesContainer from './healthcare-sites-container';

export default HealthcareSitesContainer;
